export default __webpack_public_path__ + "static/media/bg1.5b9bd6a5.jpg";